import s from "../LogoList.module.scss";
import cn from "classnames";

type Props = {
  logo: React.ReactNode;
  size?: "small" | "medium" | "large";
  transparent?: boolean;
  logoStyle?: "default" | "grayscale" | "blackAndWhite";
  logoOpacity: number;
};

const Logo = ({
  logo,
  size = "medium",
  transparent = false,
  logoStyle = "default",
  logoOpacity,
}: Props) => {
  return (
    <div className={cn(s.logo, s[size], transparent && s.transparent)}>
      <div
        className={cn(s.logoInner, logoStyle !== "default" && s[logoStyle])}
        style={{ opacity: logoOpacity }}
      >
        {logo}
      </div>
    </div>
  );
};

export default Logo;
